<template>
  <transition name="fade">
    <div class="div-add-dialog" v-if="show">
      <div class="div-container">
        <div class="div-title">添加</div>
        <input class="input-word-text" type="text" v-model="insertWord"/>
        <div class="div-container-button">
          <span class="span-container-cancel span-button" @click="close">取消</span>
          <span class="span-container-commit span-button" @click="commit">确认</span>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import funwordApi from "../api/funwordApi"
export default {
  name: 'AddDialog',
  data () {
    return {
      insertWord: ''
    }
  },
  props: ['show'],
  created () {
    console.log('created toast')
  },
  methods: {
    close () {
      this.$emit('closeDialog', false)
    },
    commit: function () {
      if (this.insertWord) {
        funwordApi.insertword({word: this.insertWord})
            .then(() => {
              this.insertWord = ''
              this.$emit('commit', true)
            })
      }
    }
  }
}
</script>

<style scoped>
.div-add-dialog {
  position: fixed;
  z-index: 1024;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
}
.div-container {
  position: absolute;
  width: 86%;
  top: 30%;
  height: 160px;
  left: 7%;
  background: lightblue;
  border-radius: 4px;
}
.div-title {
  padding: 5px 10px;
  height: 40px;
  text-align: center;
}
.input-word-text {
  height: 50px;
  width: 70%;
  border: white;
  font-size: 20px;
  font-weight: bold;
  line-height: 45px;
  padding-left: 5%;
  margin-left: 10%;
  margin-top: 10px;
}
.div-container-button {
  height: 40px;
  margin-top: 20px;
}

.span-button {
  height: 100%;
  line-height: 40px;
  width: 50%;
  text-align: center;
  font-weight: bold;
  color: white;
  display: inline-block;
}
.span-container-cancel {
  background: gray;
}
.span-container-commit {
  background: #1af;
}
</style>
